@if (visible) {
	<div class="context-menu" [style.left.px]="x" [style.top.px]="y" (click)="$event.stopPropagation()" data-testid="conversation-context-menu-container">
		<!-- Rename -->
		<button class="context-menu-item" (click)="onRename()" data-testid="conversation-context-menu-btn-rename">
			<mat-icon class="material-icons-outlined icon">edit</mat-icon>
			Rename
		</button>

		<!-- Move to project (with submenu) -->
		<div
			class="context-menu-item context-menu-item--submenu"
			(mouseenter)="onSubmenuParentEnter()"
			(mouseleave)="onSubmenuParentLeave()"
			data-testid="conversation-context-menu-item-move-to-project"
		>
			<mat-icon class="material-icons-outlined icon">folder_open</mat-icon>
			<span>Move to project</span>
			<mat-icon class="submenu-arrow">chevron_right</mat-icon>

			@if (showProjectSubmenu) {
				<div class="context-submenu" (mouseenter)="onSubmenuEnter()" (mouseleave)="onSubmenuLeave()" data-testid="conversation-context-menu-panel-project-submenu">
					@for (p of availableProjects; track p.id) {
						<button class="context-menu-item" (click)="onMoveToProject(p.id)" [attr.data-testid]="'conversation-context-menu-btn-move-to-' + p.id">
							<mat-icon class="material-icons-outlined icon">folder</mat-icon>
							{{ p.name }}
						</button>
					}
					@if (convHasProject) {
						@if (availableProjects.length > 0) {
							<div class="context-menu-divider"></div>
						}
						<button class="context-menu-item context-menu-item--danger" (click)="onMoveToProject(undefined)" data-testid="conversation-context-menu-btn-remove-from-project">
							<mat-icon class="material-icons-outlined icon">remove_circle_outline</mat-icon>
							Remove from project
						</button>
					}
					@if (availableProjects.length === 0 && !convHasProject) {
						<div class="context-menu-empty">No projects yet</div>
					}
				</div>
			}
		</div>

		<!-- Pin/Unpin -->
		<button class="context-menu-item" (click)="onTogglePin()" data-testid="conversation-context-menu-btn-toggle-pin">
			<mat-icon class="material-icons-outlined icon">push_pin</mat-icon>
			{{ convIsPinned ? 'Unpin chat' : 'Pin chat' }}
		</button>

		<div class="context-menu-divider"></div>

		<!-- Delete -->
		<button class="context-menu-item context-menu-item--danger" (click)="onDelete()" data-testid="conversation-context-menu-btn-delete">
			<mat-icon class="material-icons-outlined icon">delete</mat-icon>
			Delete
		</button>
	</div>
}
